import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(site)/faq/layout.tsx");
